import { abyssColors } from '@/theme/colors';
import { Columns } from '@/types';
import { TableData } from '@/types/table';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const POI_COLUMNS: Columns[] = [
  {
    isSortable: true,
    visibility: true,
    key: 'poiId',
    columnName: 'POI ID',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'workpackNumber',
    columnName: 'Work Pack',
    sortKey: 'workpackNumber',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'name',
    columnName: 'Name',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'assembly',
    columnName: 'Component',
    sortKey: 'assembly.tagName',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'paintRegion',
    columnName: 'Paint Block',
    sortKey: 'paintRegion.name',
    columnIcon: {
      icon: <InfoOutlinedIcon sx={{ color: abyssColors.error[600], fontSize: '2rem' }} />,
      action: 'updatePaintRegionId',
      condition: (rows: TableData[]) =>
        rows.some((row) => 'paintRegion' in row && !row.paintRegion),
      dialogTitle: 'Paint Block Error',
      dialogContent:
        'Failed to add the Paint block to the number of POIs. Please try again by clicking the button given below.',
      tooltipText: 'Some POIs are missing the paint block and need to be added manually',
    },
  },
  {
    isSortable: true,
    visibility: true,
    key: 'visibility',
    columnName: 'Visibility',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'comment',
    columnName: 'Comment',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'accessibility',
    columnName: 'Accessibility',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'status',
    columnName: 'Status',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'dueDate',
    columnName: 'Due Date',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'createdAt',
    columnName: 'Creation Date',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'isVerified',
    columnName: 'Verification',
    displayConfig: {
      type: 'VERIFICATION',
    },
  },
  {
    isSortable: true,
    visibility: true,
    key: 'type',
    columnName: 'Type',
  },
  {
    isSortable: true,
    visibility: true,
    sortKey:'paintRegion.deck.name',
    key: 'deckName',
    columnName: 'Deck',
  },
];

export const BLISTER_COLUMNS: Columns[] = [
  {
    isSortable: true,
    visibility: true,
    key: 'estimatedWallLoss',
    columnName: 'Estimated Wall Loss',
    displayUnit: 'MILLIMETER',
    sortKey: 'blister.wallLoss.value',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'residualCorrosionAllowance',
    columnName: 'Residual Corrosion Allowance',
    displayUnit: 'MILLIMETER',
    sortKey: 'blister.residualCorrosionAllowance.value',
  },
  {
    isSortable: true,
    visibility: true,
    key: 'residualThickness',
    columnName: 'Residual Thickness',
    displayUnit: 'MILLIMETER',
    sortKey: 'blister.residualThickness.value',
  },
];

export const VIEW_3D_COLUMN: Columns = {
  isSortable: false,
  visibility: true,
  key: 'view3D',
  columnName: 'View 3D',
  displayConfig: {
    type: '3DBUTTON',
  },
};
